const data = [
    {
        id: 1,
        name: "客户",
        parentId: 0,
        fee: 0,
        inFee: 0,
        laveFee: 0,
        nodeType: "1",
        level: 1,
    },
    {
        id: 2,
        name: "平台",
        parentId: '1',
        fee: 0,
        inFee: 0,
        laveFee: 0,
        nodeType: "2",
        level: 2,
    },
]
export default data;